import { render, staticRenderFns } from "./ListMaterai.vue?vue&type=template&id=a7577338&"
import script from "./ListMaterai.vue?vue&type=script&lang=js&"
export * from "./ListMaterai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports